<div nz-row [nzGutter]="{ md: 24 }">

    <div nz-col nzSpan="8" nzOffset="8">
        <nz-card style="max-width: 423px; margin: 0 auto; display: block;">
            <img src="../../../assets/img/logomarca_1.png" class="logomarca" style="width:80%; display:block; margin: 0 auto;" alt="logo">
            <p style="text-align: center; margin-top: 20px;"><strong>Alteração de Senha</strong></p>
            <form nzLayout="vertical" style="margin-top:20px!important;" nz-form [formGroup]="validateForm" class="login-form" (ngSubmit)="submitForm()">
                <nz-form-item>
                    <label for="">E-mail:</label>
                    <nz-form-control nzHasFeedback nzErrorTip="Informe um e-mail válido!">

                        <nz-input-group nzPrefixIcon="user">

                            <input type="email" readonly onfocus="this.removeAttribute('readonly');" onBlur="this.setAttribute('readonly', true);" autocomplete="off" nz-input formControlName="email" placeholder="Digite o seu e-mail" />
                        </nz-input-group>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <label for="">Senha:</label>
                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">

                        <nz-input-group nzPrefixIcon="lock">
                            <input type="password" readonly onfocus="this.removeAttribute('readonly');" onBlur="this.setAttribute('readonly', true);" autocomplete="off" nz-input formControlName="password" placeholder="******" />
                        </nz-input-group>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item>
                    <label for="">Confirmar Senha:</label>
                    <nz-form-control nzHasFeedback [nzErrorTip]="errorPassword">

                        <nz-input-group nzPrefixIcon="lock">
                            <input type="password" nz-input formControlName="password_confirmation" placeholder="******" />
                            <ng-template #errorPassword let-control>
                                <ng-container *ngIf="control.hasError('required')">
                                    Confirme sua senha!
                                </ng-container>
                                <ng-container *ngIf="control.hasError('confirm')">
                                    Senha inválida!
                                </ng-container>
                            </ng-template>
                        </nz-input-group>
                    </nz-form-control>
                </nz-form-item>
                <div nz-row [nzGutter]="{ md: 24 }">
                    <div nz-col nzSpan="12">
                        <button nz-button nzBlock class="login-form-button login-form-margin" [routerLink]="['/login']" routerLinkActive="router-link-active" [nzType]="'default'">Cancelar</button>
                    </div>
                    <div nz-col nzSpan="12">
                        <button nz-button nzBlock class="login-form-button login-form-margin" [nzType]="'primary'">Confirmar</button>
                    </div>
                </div>

            </form>
        </nz-card>
    </div>
</div>